var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderAccount',{attrs:{"orderId":_vm.orderData.id},on:{"orderAccountCancel":_vm.handleOrderAccountCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }